import React from 'react'
import { Link } from 'react-router-dom'
import { TypeAnimation } from 'react-type-animation'

const FemalePopupNumber = ({open}) => {
  return (
    <div>
    
          <div>
            <div className="popup-offer-main">
              <div className="popup-offer-content-female">
                <div className="popup-offer-content-close-btn">
                  <i
                    onClick={() => {open(false)}}
                    className="fa-solid fa-circle-xmark"
                  ></i>
                </div>
                <div className="popup-offer-head">
                  <div className="popup-offer-head-heading">Getting Ready?</div>
                  <div className="popup-offer-head-text">Experience the Best Women's Grooming by Experts at Home</div>
                </div>
                <div className="popup-offer-content-div">
                  <div className="popup-offer-content-heading-1">Get Upto</div>
                  <div className="popup-offer-content-heading-2">20% OFF</div>
                  <div className="popup-offer-content-heading-3">
                    On Women's{" "}
                    <TypeAnimation
                      sequence={[
                          "Holiday Special Grooming",
                        2500,
                        "Honeymoon Special Package",
                        2500,
                        "Wedding Groom Package",
                        2500,
                        "Lighten the Dark Skin ",
                        2500,
                      ]}
                      speed={50}
                      repeat={Infinity}
                    />
                  </div>
                          <Link to="tel:+918527273020" target='_blank' className="popup-offer-content-button-call"><i className="fa-solid fa-phone"></i> Call Us Now</Link>
                          <Link to="https://wa.me/+918527273020?text=Hello ! I'm Interested in Doorstep Female grooming Service. Please contact me." target='_blank' className="popup-offer-content-button-wa"><i class="fa-brands fa-whatsapp"></i> WhatsApp Us Now</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
  )
}

export default FemalePopupNumber
